__webpack_require__.p = "https://www.celligence.com/trademarks/";